import { cx } from 'cva';
import {
  SliderOutput as RACSliderOutput,
  type SliderOutputProps as RACSliderOutputProps,
} from 'react-aria-components/Slider';

import styles from './slider.module.css';

export type SliderOutputProps = RACSliderOutputProps;

export function SliderOutput(props: SliderOutputProps) {
  const { className, ...rest } = props;
  const classes = cx(styles.slider_output, className);
  return <RACSliderOutput className={classes} {...rest} />;
}
